import { Injectable, inject } from '@angular/core';
import { withLatestFrom, map, Observable } from 'rxjs';
import { HeatloadStore } from '../../state/heatload/heatload.store';
import { FormName, SuccessMessages } from '@nx-customer-apps/shared/enums';
import { TranslateService } from '@ngx-translate/core';
import { HeatloadFormOptionsService } from './heatload-form-options.service';
import { VentilationFormValue } from '@nx-customer-apps/shared/interfaces';
import { ProjectStore } from '../../state/project/project.store';
import { HeatloadPrefillMapper } from '../../services';
import { AccordionService } from '../../shared/interfaces';
import { VentilationFormService } from '../../shared/components/ventilation';

@Injectable({
    providedIn: 'root'
})
export class VentilationService implements AccordionService {
    private prefillMapper = inject(HeatloadPrefillMapper);
    private heatloadStore = inject(HeatloadStore);
    private formService = inject(VentilationFormService);
    private heatloadFormOptionsService = inject(HeatloadFormOptionsService);
    private projectStore = inject(ProjectStore);
    private translate = inject(TranslateService);

    public questions$ = this.heatloadStore.modernization$.pipe(
        withLatestFrom(this.projectStore.project$, this.heatloadStore.cache$, (modernization, project, cache) => ({
            modernization,
            project,
            cache
        })),
        map(state => {
            if (!state.modernization) {
                return null;
            }

            const projectPrefill = this.prefillMapper.projectToVentilationPrefill(state.project!);
            const cachePrefill = this.prefillMapper.stateToVentilationPrefill(state.cache);
            const formOptions = this.heatloadFormOptionsService.getVentilationFormOptions(cachePrefill || projectPrefill);
            return this.formService.getVentilationQuestions(formOptions);
        })
    );

    public getSuccessMessage(isVentilation: VentilationFormValue): string {
        const message = isVentilation.ventilation ? SuccessMessages.Yes : SuccessMessages.No;
        return this.translate.instant(message);
    }

    public isExpanded$ = this.isSameValueSubmitedModernizations$();

    private isSameValueSubmitedModernizations$(): Observable<boolean> {
        return this.heatloadStore.sameValueSubmited$.pipe(map(form => form?.formName === FormName.Modernizations));
    }
}
